export default __webpack_public_path__ + "static/media/apple.20878372.jpg";